import { type SVGAttributes } from 'react';
import { cn } from '../../utils/cn';
import { useI18n } from '@bravemove/i18n/react/core';

export interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, 'children'> {
  readonly size?: number;
  readonly label?: string;
}

export function Spinner({ size = 20, label, className, ...rest }: SpinnerProps) {
  const { t } = useI18n();
  return (
    <svg
      role="status"
      aria-label={label ?? t('common:status.loading', { defaultValue: 'Loading' })}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={cn('motion-safe:animate-spin text-accent-text', className)}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.25"
      />
      <path
        d="M 12 3 A 9 9 0 0 1 21 12"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
